import React, { useState } from "react";
import "./Customize.css";

function Projects() {
    const [image, setImage] = useState(null);
    const [formData, setFormData] = useState({
        name: "",
        number: "",
        customization: "",
        file: null,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "number") {
            // Allow only numbers and limit to 10 digits
            if (!/^\d{0,10}$/.test(value)) return;
        }

        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({ ...formData, file });
            setImage(URL.createObjectURL(file));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Submitted:", formData);
    };

    return (
        <div className="cust-container">
        <div className="custom-jewelry">
            <h2 className="custom-jewelry__title">Customize Your Sweets</h2>
            <form className="custom-jewelry__form" onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="name"
                    className="custom-jewelry__input"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                />

                <input
                    type="text"
                    name="number"
                    className="custom-jewelry__input"
                    placeholder="Your Mobile Number"
                    value={formData.number}
                    onChange={handleChange}
                    maxLength="10"
                    inputMode="numeric"
                    pattern="[0-9]{10}"
                    required
                />

                <select
                    name="customization"
                    className="custom-jewelry__select"
                    value={formData.customization}
                    onChange={handleChange}
                    required
                >
                    <option value="">Select Customization</option>
                    <option value="engraving">Home Made</option>
                    <option value="stone-change">Organic Items</option>
                    <option value="custom-design">Birthday sweets</option>
                </select>

                <label className="custom-jewelry__file-upload">
                    Upload Design (JPG, PNG)
                    <input type="file" accept="image/*" onChange={handleFileChange} hidden />
                </label>

                {image && <img src={image} alt="Preview" className="custom-jewelry__preview fade-in" />}

                <button type="submit" className="custom-jewelry__submit hover-glow">Submit Request</button>
            </form>
        </div>
        </div>
    );
}

export default Projects;